import React from "react";
import ExclamationIcon from "../../assets/exclamation.svg";
import { logDataHelperFunctions } from "../../helpers/logdata-helper";
import { passViewHelper } from "../../helpers/passzone/pass-zone-helper";

export const createTlogGridColumns = (
  t,
  selectedRowKeys = [],
  statusCalculationMethod = null
) => {
  function resolveNested(obj, path) {
    return path.split(".").reduce((o, key) => (o ? o[key] : undefined), obj);
  }

  const valueRender = (params) => {
    const text = params.value;
    if (text?.includes("-color")) {
      return (
        <div>
          <p className="red-note-text">
            <span className="red-note">
              {Number(text?.replace("-color", ""))}
            </span>
          </p>
        </div>
      );
    }
    return isNaN(text) ? "" : Number(text);
  };

  const unitsCommonFilter = {
    pivot: true,
    floatingFilter: true,
    filter: "agMultiColumnFilter",
    filterParams: {
      maxNumConditions: 1,
      filters: [
        {
          filter: "agNumberColumnFilter",
          filterParams: {
            valueFormatter: (params) => {
              return params.value?.replace("-color", "");
            },
            maxNumConditions: 1,
          },
        },
      ],
    },
    processCellForExport: (params) => {
      return params.value?.replace("-color", "");
    },
    valueGetter: (params) => {
      const value = resolveNested(params.data, params.colDef.field);
      return Number(value?.replace("-color", ""));
    },
    pivotComparator: (a, b) => b.localeCompare(a),
    cellRenderer: (params) => {
      const value = resolveNested(params.data, params.colDef.field);
      return valueRender({
        value: value,
      });
    },
  };

  const columns = [
    {
      headerName: t("slogColumntitle.sl.no"),
      field: "sl_no",
      key: "sl_no",
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
      cellRenderer: (params) => {
        if (
          params.data?.event &&
          selectedRowKeys?.includes(params.data?.event)
        ) {
          params.node.setSelected(true);
        } else {
          params.node.setSelected(false);
        }
        return params.value;
      },
    },
    ...(statusCalculationMethod ===
    passViewHelper.statusCalculationMethod.instantaneous
      ? [
          {
            headerName: t("slogColumntitle.status"),
            field: "statusNew",
            key: "status",
            pivotComparator: (a, b) => b.localeCompare(a),
            cellRenderer: (params) => {
              return params.value
                ? logDataHelperFunctions.getIconForStatus(params.value)
                : "-";
            },
            processCellForExport: (params) => {
              return params.value
                ? logDataHelperFunctions.getExportValueForStatus(params.value)
                : "-";
            },
            filter: "agMultiColumnFilter",
            filterParams: {
              filters: [
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    cellHeight: 40,
                    cellRenderer: (params) => {
                      const status = String(params.value);
                      if (status === "(Select All)") {
                        return "(Select All)";
                      }
                      return logDataHelperFunctions.getIconForStatus(status);
                    },
                    valueFormatter: (params) => {
                      return String(params.value);
                    },
                  },
                },
              ],
              maxNumConditions: 1,
            },
          },
        ]
      : []),
    {
      headerName: t("slogColumntitle.event"),
      field: "event",
      key: "event",
      ...unitsCommonFilter,
    },
    {
      headerName: t("slogColumntitle.jobNumber"),
      field: "jobNumber",
      key: "jobNumber",
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: t("slogColumntitle.time"),
      field: "time",
      key: "time",
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: t("slogColumntitle.tilt"),
      field: "tilt",
      key: "tilt",
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: {
              maxNumConditions: 1,
            },
          },
        ],
      },
      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: t("slogColumntitle.pipe"),
      field: "pipe",
      key: "pipe",
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: t("slogColumntitle.pass"),
      field: "pass",
      key: "pass",
      pivotComparator: (a, b) => b.localeCompare(a),
      cellRenderer: (params) => {
        return params.value == "!" ? (
          <img src={ExclamationIcon} alt="Exclamation" />
        ) : (
          params.value
        );
      },
    },
    {
      headerName: t("slogColumntitle.zone"),
      field: "zone",
      key: "zone",
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
      cellRenderer: (params) => {
        return params.value == "!" ? (
          <img src={ExclamationIcon} alt="Exclamation" />
        ) : (
          params.value
        );
      },
    },
    {
      headerName: t("slogColumntitle.distance"),
      field: "distance",
      key: "distance",
      ...unitsCommonFilter,
    },
    {
      headerName: `${t("slogColumntitle.travelSpeed")} \n`,
      field: "travelSpeed",
      key: "travelSpeed",
      ...unitsCommonFilter,
      width: 165,
    },
    {
      headerName: `${t("slogColumntitle.volt")}`,
      field: "volts",
      key: "volt",
      ...unitsCommonFilter,
    },
    {
      headerName: `${t("slogColumntitle.current")} \n`,
      field: "current",
      key: "current",
      ...unitsCommonFilter,
    },
    {
      headerName: `${t("slogColumntitle.wireSpeed")}`,
      field: "wireSpeed",
      key: "wireSpeed",
      ...unitsCommonFilter,
      width: 160,
    },
    {
      headerName: t("slogColumntitle.oscillationWidth"),
      field: "oscillationWidth",
      key: "oscillationWidth",
      ...unitsCommonFilter,
    },
    {
      headerName: t("slogColumntitle.target"),
      field: "target",
      key: "target",
      ...unitsCommonFilter,
    },
    {
      headerName: t("slogColumntitle.horizontalBias"),
      field: "horizontalBias",
      key: "horizontalBias",
      ...unitsCommonFilter,
    },
    {
      headerName: t("slogColumntitle.frequency"),
      field: "frequency",
      key: "frequency",
      ...unitsCommonFilter,
    },
    {
      headerName: t("slogColumntitle.totalWireConsumed"),
      field: "totalWireConsumed",
      key: "totalWireConsumed",
      ...unitsCommonFilter,
    },
    {
      headerName: t("slogColumntitle.trueEnergy"),
      field: "trueEnergy",
      key: "trueEnergy",
      ...unitsCommonFilter,
    },
    {
      headerName: `${t("slogColumntitle.heat")} \n`,
      field: "heat",
      key: "heat",
      ...unitsCommonFilter,
      width: 170,
    },
    {
      headerName: t("slogColumntitle.headAngel"),
      field: "headAngle",
      key: "headAngle",
      ...unitsCommonFilter,
    },
    {
      headerName: t("slogColumntitle.arcImpedance"),
      field: "arcImpedance",
      key: "arcImpedance",
      ...unitsCommonFilter,
    },
  ];

  return columns;
};
